(($, Drupal, once) => {
  Drupal.behaviors.statusMessages = {
    attach: (response, settings) => {
      // Close button.

      if ($('.messages-wrapper').length > 0) {
        window.scrollTo(0, 0);
        $('.header').addClass('blur');
        $('.layout-title').addClass('blur');
        $('.layout-content').addClass('blur');
      };

      jQuery(once('messages-close', '.messages-wrapper', response)).each(function () {
        $(this).on('click', () => {
          $('.header').removeClass('blur');
          $('.layout-title').removeClass('blur');
          $('.layout-content').removeClass('blur');
          $('.messages-wrapper').hide();
        });
      });
    },
};

$(document).ready(function () {
  const $displayErrorsContainer = $('.messages--error');
  const $formErrors = $('.form-item--error-message');

  $formErrors.text();
  // TODO: Handle displaying multiple errors as well.
  $displayErrorsContainer.append($formErrors);
});
})
(jQuery, Drupal, once);
